export const blockIconsMapsLocalOffer = (
	<span className='material-symbols-outlined'>local_offer</span>
);
